import React, { useState } from "react";
import axios from "axios";


const useUserPunchRecordTypeController = ({
    onFinish = ({ axiosMode, status, values }) => { }, //
    onBefore = ({ axiosMode, status }) => { }, //
}) => {
    const mainApi = `/cramSchool/api/user_punch_record_type`
    const [data, setData] = useState([])
    
    const getUserPunchRecordTypeData = ({
        cur_page,
        size,
        custom_filter_value,
        custom_filter_key,
        grade_class_id,
        only_date
    }) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: {
                cur_page,
                size,
                custom_filter_value,
                custom_filter_key,
                grade_class_id,
                only_date
            },
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: {
                                data: [],
                                total: 0
                            }
                        }
                    )
                }
                return {
                    ...data
                }
            });
    }
    return {
        userPunchRecordTypeDatas: data,
        getUserPunchRecordTypeData,
        // postSystemHolidaySettingData,
        // patchSystemHolidaySettingData,
        // deleteSystemHolidaySettingData,
    }
}
export { useUserPunchRecordTypeController }
